import { render } from "./IconForm.vue?vue&type=template&id=8ea092ca&ts=true"
import script from "./IconForm.vue?vue&type=script&lang=ts"
export * from "./IconForm.vue?vue&type=script&lang=ts"

import "./IconForm.vue?vue&type=style&index=0&id=8ea092ca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__